/**
 * P1 — MSAL (SPA) configuration. The owner signs in against their own tenant; the
 * access token is requested for the licensing API scope (api://{appId}/admin.access)
 * so its audience matches what the backend's /owner/* gate accepts. Owner-only is
 * ENFORCED by the backend (oid allow-list) — this UI just reflects it.
 */
import { Configuration, PublicClientApplication } from "@azure/msal-browser";
import { authority, config } from "../config";

export const msalConfig: Configuration = {
  auth: {
    clientId: config.clientId,
    authority,
    redirectUri: window.location.origin,
    postLogoutRedirectUri: window.location.origin,
  },
  cache: {
    cacheLocation: "sessionStorage",
    // Helps the silent-renew flow complete in browsers that block third-party
    // cookies (otherwise the hidden iframe times out → monitor_window_timeout).
    storeAuthStateInCookie: true,
  },
};

/** Scopes for acquiring an access token to call /owner/*. */
export const apiRequest = { scopes: [config.apiScope] };

/** Login uses the API scope so the first token is already API-audience. */
export const loginRequest = { scopes: [config.apiScope] };

/** Microsoft Graph token for the directory people-picker (Administratorzy). */
export const graphRequest = { scopes: ["User.ReadBasic.All"] };

export const msalInstance = new PublicClientApplication(msalConfig);
